import React, { useEffect, useState } from 'react'
import FunctionalityForm from './form'
import FunctionalityTable from './table'
import SecurityAdministrationLayout from '../../commons/SecurityAdministrationLayout'
import { getFromApi, postToApi, putToApi } from 'actions'
import { VALUES } from 'utils/constants'
import { buildFiltersDescriptors } from '../../commons/SearchFilters'
import omit from 'lodash/omit'
import { useStateValue } from 'context/store'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { closeSpinnerAction, openSpinnerAction } from 'context/reducers/openSpinnerReducer'

const INITIAL_FUNCTIONALITY_FORM_STATE = {
   name: '',
   description: '',
   application: '',
   isnotified: ''
}

const TITLE = {
   [VALUES.FORM_BEHAVIOR.REGISTER]: 'Registrar Bucket'
}

const Functionality = ({ isSearch }) => {
   const [isShowingPopover, setPopoverProp] = useState(true)
   const [allActiveApplications, setAllActiveApplications] = useState([])
   const [modulesByAppId, setModulesByAppId] = useState([])

   const [formData, setFormData] = useState(INITIAL_FUNCTIONALITY_FORM_STATE)
   const [formBehavior, setFormBehavior] = useState(
      isSearch ? VALUES.FORM_BEHAVIOR.SEARCH : VALUES.FORM_BEHAVIOR.REGISTER
   )
   const [tableData, setTableData] = useState(VALUES.TABLE_DATA_INTIAL_STATE)
   const [paginationParams, setPaginationParams] = useState(VALUES.PAGING_ORDER_INITIAL_STATE)
   const [searchFilters, setSearchFilters] = useState({})
   const [options, setOptions] = useState([...VALUES.STATUS_OPTIONS])

   const [_, dispatch] = useStateValue()

   // ---------------- Clean Form -----------------
   function cleanForm() {
      setFormData({
         ...INITIAL_FUNCTIONALITY_FORM_STATE
      })
      setFormBehavior(isSearch ? VALUES.FORM_BEHAVIOR.SEARCH : VALUES.FORM_BEHAVIOR.REGISTER)
   }

   function clean() {
      setSearchFilters({})
      setTableData(VALUES.TABLE_DATA_INTIAL_STATE)
      setPopoverProp(true)
      setPaginationParams(VALUES.PAGING_ORDER_INITIAL_STATE)
      cleanForm()
   }

   useEffect(() => {
      clean()
   }, [isSearch]) // eslint-disable-line react-hooks/exhaustive-deps

   // ------------- Fetch all Initial Active Applications  -----------------
   async function _getAllActiveApplications() {
      const url = `${process.env.REACT_APP_APPLICATIONS_API}/applications/active`
      const activeApplications = await getFromApi(url)
      setAllActiveApplications(activeApplications)
   }

   const getAllActiveApplications = useApiRequest(
      _getAllActiveApplications,
      'Funcionalidades: Consultar Aplicaciones Activas'
   )

   useEffect(() => {
      getAllActiveApplications()
   }, [])

   // ------------ Fetch Modules by Application Id

   // ------------ Search Functionlities -----------------
   const getFiltersDescriptors = filters => {
      let { module, ...otherFilters } = filters
      otherFilters = omit(otherFilters, ['application'])
      const descriptors =
         buildFiltersDescriptors(options)({
            ...otherFilters,
            module: module?.id
         }) || []
      return descriptors
   }

   const removeSearchFilter = async filter => {
      const remainingFilters = omit(searchFilters, [filter.filterName])
      await searchFunctionality(remainingFilters, VALUES.PAGING_ORDER_INITIAL_STATE)
   }

   async function _searchFunctionality(externalFilters, pagingFromTableParams = {}) {
      const filters = externalFilters ? externalFilters : searchFilters
      const paginationFilters = {
         ...paginationParams,
         ...pagingFromTableParams
      }
      setSearchFilters(filters)
      setPaginationParams(paginationFilters)
      const data = {}
      if (filters.name) {
         data.name = filters.name
      }
      if (filters.module) {
         data.moduleId = filters.module.id
      }
      if (filters.status) {
         data.status = filters.status
      }
      const payload = { ...data, ...paginationFilters }
      const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/search`
      const searchedFunctionalities = await getFromApi(url, payload)
      setTableData(searchedFunctionalities)
      setFormData(INITIAL_FUNCTIONALITY_FORM_STATE)
   }

   const searchFunctionality = useApiRequest(_searchFunctionality, 'Funcionalidades: Consultar')

   // ------------ Register Functionlities -----------------
   async function _createBucket() {
      const payload = {
         name: formData.name,
         description: formData.description,
         applicationName: formData.application,
         isnotified: formData.isnotified,
         modifiedBy: 'yesi'
      }
      const url = `${process.env.REACT_APP_BASE_API_FILE_EXPLORER}/core/files/save`
      // const url = `https://gqfileexplore.mutualser.com/core/files/save`
      const registeredFunctionality = await postToApi(url, payload)

      setTableData({
         ...VALUES.TABLE_DATA_INTIAL_STATE,
         data: [registeredFunctionality]
      })
      setFormData(INITIAL_FUNCTIONALITY_FORM_STATE)
      dispatch(openSnackBarAction(`Se guardó correctamente la Funcionalidad ${registeredFunctionality.name}`, 'info'))
   }

   const createBucket = useApiRequest(_createBucket, 'Bucket: Crear' )

   // -------------- Form Actions ---------------
   const actionSubmit = type => {
      setPopoverProp(false)
      createBucket()
   }

   return (
      <SecurityAdministrationLayout
         title={TITLE[formBehavior]}
         form={
            <FunctionalityForm
               formData={formData}
               setForm={setFormData}
               modules={modulesByAppId}
               setModules={setModulesByAppId}
               actionSubmit={actionSubmit}
               formBehavior={formBehavior}
               cleanCallback={cleanForm}
               applications={allActiveApplications}
            />
         }
         table={
            <FunctionalityTable
               isSearch={isSearch}
               order={paginationParams.order}
               functionalities={tableData}
               searchFunctionalitites={searchFunctionality}
               cleanCallback={clean}
            />
         }
         popoverProp={isShowingPopover}
         setPopoverProp={setPopoverProp}
         searchFilters={getFiltersDescriptors(searchFilters)}
         onRemoveFilter={removeSearchFilter}
      />
   )
}

export default Functionality
